import React from 'react';
import { useSelector } from 'react-redux';

import { useParams } from 'react-router-dom';
import type { RootState } from '../../../reducers';
import { isGuaranteePackageLandingPage, isLandingPage } from '../../../selectors/content-page';
import { isListPage } from '../../../selectors/list';
import { reselectors } from '../../../utils';
import ErrorSelector from '../../error/error-selector';
import ListPage from '../list-page';
import ContentPage from './content-page';
import GuaranteePackageLandingPage from './guarantee-package-landing-page';
import LandingPage from './landing-page';

const ContentPageSelector = () => {
  const urlParams = useParams();
  const slug = (urlParams?.child || urlParams?.parent)!;
  const isErrorPage = useSelector(reselectors.isErrorPage);
  const listPage = useSelector<RootState, boolean>((s) => isListPage(s, slug));
  const pageIsSearchLandingPage = useSelector<RootState, boolean>((s) => isLandingPage(s, slug));
  const pageIsGuaranteePackageLandingPage = useSelector<RootState, boolean>((s) =>
    isGuaranteePackageLandingPage(s, slug),
  );

  if (isErrorPage) return <ErrorSelector />;
  if (listPage) return <ListPage slug={slug} />;
  if (pageIsSearchLandingPage) return <LandingPage slug={slug} />;
  if (pageIsGuaranteePackageLandingPage) return <GuaranteePackageLandingPage slug={slug} />;

  return <ContentPage slug={slug} />;
};

export default ContentPageSelector;
